import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import localize from "@/utils/localization";
import Alert from "components/Alert.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CleanupResultDialog',
    props: {
        result: { default: undefined }
    },
    setup(__props, { expose }) {
        const props = __props;
        const showModal = ref(false);
        const isLoading = computed(() => {
            return props.result === undefined;
        });
        const title = computed(() => {
            let message = localize("Something went wrong...");
            if (isLoading.value) {
                message = localize("Freeing up some space...");
            }
            else if (props.result.isPartialSuccess) {
                message = localize("Sorry, some items couldn't be cleared");
            }
            else if (props.result.success) {
                message = localize("Congratulations!");
            }
            return message;
        });
        const errorFields = [
            { key: "name", label: localize("Name") },
            { key: "reason", label: localize("Reason") },
        ];
        function openModal() {
            showModal.value = true;
        }
        expose({
            openModal,
        });
        return { __sfc: true, props, showModal, isLoading, title, errorFields, openModal, Alert };
    }
});
